import React, { useState, useEffect } from 'react';
import { db } from './firebase';
import { 
    collection, onSnapshot, doc, updateDoc, increment, query, 
    orderBy, addDoc, serverTimestamp, deleteDoc, arrayUnion, setDoc, getDoc 
} from 'firebase/firestore';

const AdminPanel = ({ onBack }) => {
    // --- States ---
    const [users, setUsers] = useState([]);
    const [requests, setRequests] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [videos, setVideos] = useState([]);
    const [submissions, setSubmissions] = useState([]); 
    const [promoCodes, setPromoCodes] = useState([]);
    const [activeTab, setActiveTab] = useState('dashboard'); 
    const [customPoints, setCustomPoints] = useState({});
    const [shopOrders, setShopOrders] = useState([]);
    const [shopItems, setShopItems] = useState([]);
    const [editItem, setEditItem] = useState(null); // Edit လုပ်မယ့် Item ကို သိမ်းရန်
    
        // Form & UI States
    const [itemName, setItemName] = useState('');
    const [itemPricePts, setItemPricePts] = useState('');
    const [itemPriceMmk, setItemPriceMmk] = useState('');
    const [itemCategory, setItemCategory] = useState('PREMIUM');
    const [itemSubCat, setItemSubCat] = useState('PREMIUM');
    const [rejectOrder, setRejectOrder] = useState(null); 
    const [rejectReason, setRejectReason] = useState('');
    
    // Modals
    const [showPlanModal, setShowPlanModal] = useState(null);
    const [viewImg, setViewImg] = useState(null); 

    // Settings & Forms
    const [ytApiKey, setYtApiKey] = useState('');
    const [targetChannelId, setTargetChannelId] = useState('');
    const [adsFreePoints, setAdsFreePoints] = useState(5);
    const [adsPremiumPoints, setAdsPremiumPoints] = useState(10);
    const [adsterraLink, setAdsterraLink] = useState('');
    const [dailyAdLimit, setDailyAdLimit] = useState(20);
    const [vpnCheckEnabled, setVpnCheckEnabled] = useState(false);
    const [vpnAction, setVpnAction] = useState('block');

    const [taskTitle, setTaskTitle] = useState('');
    const [taskType, setTaskType] = useState('YouTube');
    const [taskLink, setTaskLink] = useState('');
    const [taskPoints, setTaskPoints] = useState('');
    const [targetMember, setTargetMember] = useState('Free');

    const [vidTitle, setVidTitle] = useState('');
    const [vidUrl, setVidUrl] = useState('');

    const [pCode, setPCode] = useState('');
    const [pReward, setPReward] = useState('');
    const [pLimit, setPLimit] = useState('');

    // --- Data Loading ---
    useEffect(() => {
        const unsubUsers = onSnapshot(collection(db, "users"), (s) => setUsers(s.docs.map(d => ({ id: d.id, ...d.data() }))));
        const unsubRequests = onSnapshot(query(collection(db, "wallet_requests"), orderBy("createdAt", "desc")), (s) => setRequests(s.docs.map(d => ({ id: d.id, ...d.data() }))));
        const unsubTasks = onSnapshot(query(collection(db, "tasks"), orderBy("createdAt", "desc")), (s) => setTasks(s.docs.map(d => ({ id: d.id, ...d.data() }))));
        const unsubVideos = onSnapshot(query(collection(db, "videos"), orderBy("createdAt", "desc")), (s) => setVideos(s.docs.map(d => ({ id: d.id, ...d.data() }))));
        const unsubItems = onSnapshot(collection(db, "shop_items"), (s) => setShopItems(s.docs.map(d => ({ id: d.id, ...d.data() }))));
        const unsubOrders = onSnapshot(query(collection(db, "shop_orders"), orderBy("createdAt", "desc")), (s) => setShopOrders(s.docs.map(d => ({ id: d.id, ...d.data() }))));

        // Task Submissions Listener
        const unsubSubs = onSnapshot(query(collection(db, "task_submissions"), orderBy("createdAt", "desc")), (s) => {
            setSubmissions(s.docs.map(d => ({ id: d.id, ...d.data() })));
        });

        const unsubPromo = onSnapshot(collection(db, "promo_codes"), (s) => setPromoCodes(s.docs.map(d => ({ id: d.id, ...d.data() }))));

        getDoc(doc(db, "admin", "settings")).then(s => {
            if(s.exists()){
                const d = s.data();
                setYtApiKey(d.youtubeApiKey || '');
                setTargetChannelId(d.targetChannelId || '');
                setAdsFreePoints(d.adsFreePoints || 5);
                setAdsPremiumPoints(d.adsPremiumPoints || 10);
                setAdsterraLink(d.adsterraLink || '');
                setDailyAdLimit(d.dailyAdLimit || 20);
                setVpnCheckEnabled(d.vpnCheckEnabled || false);
                setVpnAction(d.vpnAction || 'block');
            }
        });

        return () => { 
            unsubUsers(); unsubRequests(); unsubTasks(); unsubVideos(); unsubSubs(); unsubPromo(); unsubItems(); unsubOrders();
        };
    }, []);

        const handleAddItem = async () => {
        if (!itemName || !itemPricePts || !itemPriceMmk) return alert("အချက်အလက်ပြည့်စုံအောင်ဖြည့်ပါ");
        try {
            await addDoc(collection(db, "shop_items"), {
                name: itemName,
                pricePts: Number(itemPricePts),
                priceMmk: Number(itemPriceMmk),
                mainCat: itemCategory,
                subCat: itemSubCat,
                createdAt: serverTimestamp()
            });
            setItemName(''); setItemPricePts(''); setItemPriceMmk('');
            alert("Product Added! ✅");
        } catch (err) { alert(err.message); }
    };

    const handleUpdateItem = async () => {
        if (!editItem.name || !editItem.pricePts || !editItem.priceMmk) return alert("အချက်အလက်ဖြည့်ပါ");
        try {
            const itemRef = doc(db, "shop_items", editItem.id);
            await updateDoc(itemRef, {
                name: editItem.name,
                pricePts: Number(editItem.pricePts),
                priceMmk: Number(editItem.priceMmk),
                mainCat: editItem.mainCat,
                subCat: editItem.subCat
            });
            setEditItem(null); // Modal ပိတ်ရန်
            alert("Product Updated! ✅");
        } catch (err) { alert(err.message); }
    };

     const handleApproveOrder = async (order) => {
        try {
            const orderRef = doc(db, "shop_orders", order.id);
            const userRef = doc(db, "users", order.userId);
            await updateDoc(orderRef, { status: 'completed', updatedAt: serverTimestamp() });

            if (order.mainCat?.toUpperCase() === 'PREMIUM') {
                const dayMatch = order.productName.match(/\d+/);
                const daysToAdd = dayMatch ? parseInt(dayMatch[0]) : 30;

                const userSnap = await getDoc(userRef);
                const uData = userSnap.data();
                
                // ၁။ ရက်ဟောင်းနဲ့ ရက်သစ်ကို ပေါင်းမယ်
                let currentExpiry = uData.expiryDate ? uData.expiryDate.toDate() : new Date();
                if (currentExpiry < new Date()) currentExpiry = new Date();
                currentExpiry.setDate(currentExpiry.getDate() + daysToAdd);

                // ၂။ ကျန်ရှိမည့် ရက်ပေါင်းကို တွက်မယ်
                const diffTime = currentExpiry - new Date();
                const totalDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                await updateDoc(userRef, {
                    premium: totalDays,
                    expiryDate: currentExpiry,
                    memberType: 'Premium'
                });
            }
            alert("Approve Success! ✅");
        } catch (err) { alert(err.message); }
    };

    const handleConfirmReject = async () => {
        if (!rejectReason) return alert("ဘာကြောင့် Reject လုပ်တာလဲ ရေးပေးပါ");
        try {
            const orderRef = doc(db, "shop_orders", rejectOrder.id);
            if (rejectOrder.paymentMethod === 'points') {
                const userRef = doc(db, "users", rejectOrder.userId);
                await updateDoc(userRef, { points: increment(Number(rejectOrder.price)) });
            }
            await updateDoc(orderRef, { 
                status: 'rejected', 
                reason: rejectReason,
                updatedAt: serverTimestamp() 
            });
            setRejectOrder(null); setRejectReason('');
            alert("Order Rejected! ❌");
        } catch (err) { alert(err.message); }
    };

    const handlePointUpdate = async (userId, type) => {
            const amount = Number(customPoints[userId]);
            if (!amount || amount <= 0) return alert("ပမာဏမှန်အောင်ထည့်ပါ");
            await updateDoc(doc(db, "users", userId), { points: increment(type === 'add' ? amount : -amount) });
            setCustomPoints({ ...customPoints, [userId]: "" });
        };

    // --- Handlers ---
    const handleApprove = async (req) => {
        try {
            if(req.type === 'deposit'){
                await updateDoc(doc(db, "users", req.userId), { points: increment(Number(req.amount)) });
            }
            await updateDoc(doc(db, "wallet_requests", req.id), { status: 'approved' });
            alert("Success!");
        } catch (err) { alert(err.message); }
    };

    const handleApproveTask = async (sub) => {
        try {
            await updateDoc(doc(db, "users", sub.userId), { 
                points: increment(Number(sub.points)), 
                doneTasks: arrayUnion(sub.taskId) 
            });
            await updateDoc(doc(db, "task_submissions", sub.id), { status: 'approved' });
            alert("Verified! ✅");
        } catch (err) { alert(err.message); }
    };

    const handleTaskReject = async (sub) => {
        try {
            await updateDoc(doc(db, "task_submissions", sub.id), { status: 'rejected' });
            alert("Task Rejected ❌");
        } catch (err) { alert(err.message); }
    };

    const handleSaveSettings = async () => {
        try {
            await setDoc(doc(db, "admin", "settings"), {
                youtubeApiKey: ytApiKey,
                targetChannelId: targetChannelId,
                adsFreePoints: Number(adsFreePoints),
                adsPremiumPoints: Number(adsPremiumPoints),
                adsterraLink: adsterraLink,
                dailyAdLimit: Number(dailyAdLimit),
                vpnCheckEnabled: vpnCheckEnabled,
                vpnAction: vpnAction
            });
            alert("Settings Saved!");
        } catch (err) { alert(err.message); }
    };

    const handleAddTask = async () => {
        if (!taskTitle || !taskLink || !taskPoints) return alert("Fill details");
        try {
            await addDoc(collection(db, "tasks"), { 
                title: taskTitle, type: taskType, link: taskLink, 
                points: Number(taskPoints), memberLevel: targetMember, 
                createdAt: serverTimestamp() 
            });
            setTaskTitle(''); setTaskLink(''); setTaskPoints(''); alert("Task Added!");
        } catch (err) { alert(err.message); }
    };

    const handleMakePremium = async (userId, months, days = 0) => {
        try {
            const expiry = new Date();
            if (days > 0) expiry.setDate(expiry.getDate() + days);
            else expiry.setMonth(expiry.getMonth() + months);
            await updateDoc(doc(db, "users", userId), { memberType: 'Premium', expiryDate: expiry.toISOString() });
            setShowPlanModal(null); 
            alert("Premium Updated Successfully! ✅");
        } catch (err) { alert(err.message); }
    };

    const handleAddVideo = async () => {
        if(!vidTitle || !vidUrl) return alert("Fill video info");
        await addDoc(collection(db, "videos"), { title: vidTitle, url: vidUrl, createdAt: serverTimestamp() });
        setVidTitle(''); setVidUrl('');
    };



    const handleAddPromo = async () => {
        if(!pCode || !pReward || !pLimit) return alert("Fill promo info");
        await addDoc(collection(db, "promo_codes"), { code: pCode.toUpperCase(), reward: Number(pReward), limit: Number(pLimit), usedBy: [], createdAt: serverTimestamp() });
        setPCode(''); setPReward(''); setPLimit('');
    };

    return (
        <div style={styles.container}>
            {/* Sidebar */}
            <div style={styles.sidebar}>
                <h2 style={styles.logo}>BABYLON</h2>
                <div style={{ flex: 1, overflowY: 'auto', marginBottom: '10px', paddingRight: '5px' }}>
                    <SidebarItem icon="dashboard" label="Overview" active={activeTab === 'dashboard'} onClick={() => setActiveTab('dashboard')} />
                    <SidebarItem icon="storefront" label="Shop Editor" active={activeTab === 'shop_editor'} onClick={() => setActiveTab('shop_editor')} />
                    <SidebarItem icon="shopping_bag" label="Orders List" active={activeTab === 'orders'} onClick={() => setActiveTab('orders')} />
                    <SidebarItem icon="people" label="Users List" active={activeTab === 'users'} onClick={() => setActiveTab('users')} />
                    <SidebarItem icon="payments" label="Wallet Requests" active={activeTab === 'wallet'} onClick={() => setActiveTab('wallet')} />
                    <SidebarItem icon="fact_check" label="Task Verification" active={activeTab === 'verification'} onClick={() => setActiveTab('verification')} />
                    <SidebarItem icon="video_library" label="Playlist" active={activeTab === 'videos'} onClick={() => setActiveTab('videos')} />
                    <SidebarItem icon="assignment" label="Tasks Management" active={activeTab === 'tasks'} onClick={() => setActiveTab('tasks')} />
                    <SidebarItem icon="card_giftcard" label="Promo Codes" active={activeTab === 'promo'} onClick={() => setActiveTab('promo')} />
                    <SidebarItem icon="security" label="Settings & VPN" active={activeTab === 'settings'} onClick={() => setActiveTab('settings')} />
                </div>
                <button onClick={onBack} style={styles.backBtn}>Exit Panel</button>
            </div>

            {/* Main Content */}
            <div style={styles.mainContent}>
                {activeTab === 'dashboard' && (
                    <div style={styles.dashboardGrid}>
                        <StatCard label="Total Users" value={users.length} icon="groups" color="#3498db" />
                        <StatCard label="Wallet Requests" value={requests.filter(r => r.status === 'pending').length} icon="account_balance_wallet" color="#e67e22" />
                        <StatCard label="Task Submissions" value={submissions.filter(s => s.status === 'pending').length} icon="task" color="#2ecc71" />
                    </div>
                )}
                
                {activeTab === 'shop_editor' && (
                                        <div>
                                            <h3 style={styles.tabTitle}>SHOP EDITOR</h3>
                                            <div style={{...styles.formGrid, gridTemplateColumns: 'repeat(3, 1fr)'}}>
                                                <div style={styles.inputGroup}>
                                                    <label style={styles.label}>1. Main Category</label>
                                                    <select value={itemCategory} onChange={(e) => {
                                                        setItemCategory(e.target.value);
                                                        if(e.target.value === 'PREMIUM') setItemSubCat('PREMIUM');
                                                        else if(e.target.value === 'GAMES') setItemSubCat('MLBB');
                                                        else if(e.target.value === 'TOPUP') setItemSubCat('MPT');
                                                    }} style={styles.input}>
                                                        <option value="PREMIUM">PREMIUM</option>
                                                        <option value="GAMES">GAMES</option>
                                                        <option value="TOPUP">TOPUP</option>
                                                    </select>
                                                </div>
                                                <div style={styles.inputGroup}>
                                                    <label style={styles.label}>2. Sub Category</label>
                                                    <select value={itemSubCat} onChange={(e) => setItemSubCat(e.target.value)} style={styles.input}>
                                                        {itemCategory === 'PREMIUM' && <option value="PREMIUM">Premium Plan</option>}
                                                        {itemCategory === 'GAMES' && <>
                                                            <option value="MLBB">MLBB</option>
                                                            <option value="PUBG">PUBG</option>
                                                        </>}
                                                        {itemCategory === 'TOPUP' && <>
                                                            <option value="MPT">MPT</option>
                                                            <option value="ATOM">ATOM</option>
                                                            <option value="OOREDOO">OOREDOO</option>
                                                            <option value="MYTEL">MYTEL</option>
                                                        </>}
                                                    </select>
                                                </div>
                                                <div style={styles.inputGroup}>
                                                    <label style={styles.label}>3. Item Name</label>
                                                    <input placeholder="30 Days Premium" value={itemName} onChange={(e) => setItemName(e.target.value)} style={styles.input} />
                                                </div>
                                                <div style={styles.inputGroup}>
                                                    <label style={styles.label}>4. Pts Price</label>
                                                    <input type="number" value={itemPricePts} onChange={(e) => setItemPricePts(e.target.value)} style={styles.input} />
                                                </div>
                                                <div style={styles.inputGroup}>
                                                    <label style={styles.label}>5. Mmk Price</label>
                                                    <input type="number" value={itemPriceMmk} onChange={(e) => setItemPriceMmk(e.target.value)} style={styles.input} />
                                                </div>
                                                <button onClick={handleAddItem} style={{...styles.primaryBtn, alignSelf: 'flex-end', height: '45px'}}>ADD ITEM</button>
                                            </div>
                                            <table style={{...styles.table, marginTop: '30px'}}>
                                                <thead>
                                                    <tr style={styles.thRow}>
                                                        <th style={styles.th}>CAT</th>
                                                        <th style={styles.th}>BRAND</th>
                                                        <th style={styles.th}>NAME</th>
                                                        <th style={styles.th}>PRICES</th>
                                                        <th style={styles.th}>ACTION</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {shopItems.map(i => (
                                                    <tr key={i.id} style={styles.tr}>
                                                    <td style={styles.td}>{i.mainCat}</td>
                                                    <td style={styles.td}><b>{i.subCat}</b></td>
                                                    <td style={styles.td}>{i.name}</td>
                                                    <td style={styles.td}>{i.pricePts} Pts / {i.priceMmk} K</td>
                                                    <td style={styles.td}>
                                                    {/* Edit Button */}
                                                    <button 
                                                    onClick={() => setEditItem(i)} 
                                                    style={{color:'#3498db', border:'none', background:'none', cursor:'pointer', marginRight:'10px', fontWeight:'bold'}}
                                                    >
                                                    Edit
                                                    </button>
                                         
                                                   {/* Delete Button */}
                                                   <button 
                                                   onClick={() => deleteDoc(doc(db, "shop_items", i.id))} 
                                                   style={{color:'#ff4444', border:'none', background:'none', cursor:'pointer'}}
                                                   >
                                                    Delete
                                                  </button>
                                                 </td>
                                                </tr>
                                              ))}
                                                </tbody>
                                            </table>
                                        </div> 
                                     )}
                                
                    {activeTab === 'orders' && (
                        <div style={{overflowX: 'auto'}}>
                            <h3 style={styles.tabTitle}>SHOP ORDERS</h3>
                            <table style={styles.table}>
                                <thead>
                                    <tr style={styles.thRow}>
                                        <th style={styles.th}>USER / PRODUCT</th>
                                        <th style={styles.th}>PAYMENT INFO</th>
                                        <th style={styles.th}>DELIVERY INFO</th>
                                        <th style={styles.th}>ACTION</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {shopOrders.map(order => (
                                   <tr key={order.id} style={styles.tr}>
                                <td style={styles.td}>
                              {/* User ID ကို အပေါ်ဆုံးမှာ ရွှေရောင်နဲ့ပြမည် */}
                             <div style={{fontWeight: 'bold', fontSize: '11px', color: '#D4AF37'}}>
                              ID: {order.userId}
                             </div>
                             {/* User Email ကို အောက်မှာပြမည် */}
                               <div style={{fontSize: '12px', color: '#8b949e', marginBottom: '4px'}}>
                                {order.userEmail || 'No Email'}
                              </div>
                              {/* ဝယ်ယူထားသည့် ပစ္စည်းအမည် */}
                              <b style={{color: '#fff'}}>{order.productName}</b>
                                 </td>
                                     {/* ... ကျန်တဲ့ Payment Info အပိုင်းတွေ ဆက်သွားပါလိမ့်မယ် ... */}
                                            {/* FIX 2 & 3: CashType (Kpay/Wave) နဲ့ Acc Number ပေါ်အောင်ပြင်ထားသည် */}
                                            <td style={styles.td}>
                                            <div style={{fontSize:'12px'}}>
                                            <b>Method:</b> {order.paymentMethod} {order.cashType ? `(${order.cashType})` : ''}<br/>
        
                                          {/* လွှဲသူအမည်ကို ဒီနေရာမှာ ထည့်ပြပါမည် */}
                                          {order.paymentMethod === 'cash' && (
                                          <><b>လွှဲသူအမည်:</b> <span style={{color:'#3498db'}}>{order.details?.accName || 'N/A'}</span><br/></>
                                         )}

                                         <b>Acc No:</b> <span style={{color:'#D4AF37'}}>{order.details?.accNumber || 'N/A'}</span><br/>
                                         <b>Amt:</b> {order.price?.toLocaleString()} {order.paymentMethod === 'points' ? 'Pts' : 'K'}<br/>
                                         <b>TXN:</b> <span style={{color:'#00ff00'}}>{order.details?.transactionId || 'N/A'}</span>
                                          </div>
                                          </td>
                                            <td style={styles.td}>
                                                <div style={{fontSize:'12px', color:'#3498db'}}>
                                                    {order.details?.playerID && <><b>Game ID:</b> {order.details.playerID}<br/></>}
                                                    {order.details?.phoneNumber && <><b>Phone:</b> {order.details.phoneNumber}</>}
                                                </div>
                                            </td>
                                            <td style={styles.td}>
                                                {order.status === 'pending' ? (
                                                    <div style={{display:'flex', gap:'5px'}}>
                                                        <button onClick={() => handleApproveOrder(order)} style={styles.approveBtn}>Approve</button>
                                                        <button onClick={() => setRejectOrder(order)} style={{...styles.approveBtn, background:'#ff4444'}}>Reject</button>
                                                    </div>
                                                ) : (
                                                    <span style={{color: order.status === 'completed' ? '#2ecc71' : '#ff4444', fontWeight:'bold'}}>
                                                        {order.status === 'completed' ? 'Success ✅' : 'Rejected ❌'}
                                                    </span>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                           </table>
                         </div>
                        )}

{editItem && (
    <div style={styles.overlay}>
        <div style={{...styles.modal, width: '400px', background: '#161b22'}}>
            <h3 style={{color:'#D4AF37', marginTop:0}}>Edit Product</h3>
            <div style={{display:'flex', flexDirection:'column', gap:'10px'}}>
                <label style={{fontSize:'12px', color:'#8b949e'}}>Item Name</label>
                <input 
                    value={editItem.name} 
                    onChange={(e) => setEditItem({...editItem, name: e.target.value})} 
                    style={styles.input} 
                />
                
                <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px'}}>
                    <div>
                        <label style={{fontSize:'12px', color:'#8b949e'}}>Price (Pts)</label>
                        <input 
                            type="number" 
                            value={editItem.pricePts} 
                            onChange={(e) => setEditItem({...editItem, pricePts: e.target.value})} 
                            style={styles.input} 
                        />
                    </div>
                    <div>
                        <label style={{fontSize:'12px', color:'#8b949e'}}>Price (Mmk)</label>
                        <input 
                            type="number" 
                            value={editItem.priceMmk} 
                            onChange={(e) => setEditItem({...editItem, priceMmk: e.target.value})} 
                            style={styles.input} 
                        />
                    </div>
                </div>
            </div>

            <div style={{display:'flex', gap:'10px', marginTop:'20px'}}>
                <button onClick={handleUpdateItem} style={{...styles.approveBtn, flex:1}}>UPDATE</button>
                <button onClick={() => setEditItem(null)} style={{...styles.backBtn, flex:1, marginTop:0}}>CANCEL</button>
            </div>
        </div>
    </div>
)}
            {rejectOrder && (
                <div style={styles.overlay}>
                    <div style={styles.modal}>
                        <h4 style={{color:'#ff4444', marginTop:0}}>Reject Order</h4>
                        <textarea 
                            value={rejectReason} 
                            onChange={(e) => setRejectReason(e.target.value)} 
                            placeholder="အကြောင်းပြချက်ရေးပါ..." 
                            style={styles.textarea}
                        />
                        <div style={{display:'flex', gap:'10px', marginTop:'15px'}}>
                            <button onClick={handleConfirmReject} style={{...styles.primaryBtn, flex:1, background:'#ff4444'}}>Confirm</button>
                            <button onClick={() => setRejectOrder(null)} style={{...styles.primaryBtn, flex:1, background:'#30363d'}}>Cancel</button>
                        </div>
                    </div>
                </div>
            )}
              </div>
        

                {activeTab === 'users' && (
                    <div style={styles.card}>
                        <h3 style={styles.tabTitle}>USERS MANAGEMENT</h3>
                        <div style={{overflowX: 'auto'}}>
                            <table style={styles.table}>
                                <thead>
                                    <tr style={styles.thRow}>
                                        <th style={styles.th}>USER</th>
                                        <th style={styles.th}>STATUS</th>
                                        <th style={styles.th}>POINTS</th>
                                        <th style={styles.th}>ACTION</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {users.map(u => (
                                        <tr key={u.id} style={styles.tr}>
                                            <td style={styles.td}>
                                                <div style={{fontWeight: 'bold', color: '#fff'}}>{u.email}</div>
                                                <div style={{fontSize: '11px', color: '#8b949e'}}>{u.uid}</div>
                                            </td>
                                            <td style={styles.td}>
                                                <span style={{color: u.memberType === 'Premium' ? '#D4AF37' : '#8b949e', fontWeight: 'bold'}}>
                                                    {u.memberType || 'Free'}
                                                </span>
                                            </td>
                                            <td style={styles.td}>
                                                <div style={{color: '#2ecc71', fontWeight: 'bold'}}>{u.points || 0} Pts</div>
                                            </td>
                                            <td style={styles.td}>
                                                <div style={{display: 'flex', gap: '5px', alignItems: 'center'}}>
                                                    <input type="number" placeholder="Amt" value={customPoints[u.id] || ""} onChange={(e) => setCustomPoints({...customPoints, [u.id]: e.target.value})} style={styles.miniInput}/>
                                                    <button onClick={() => handlePointUpdate(u.id, 'add')} style={styles.addBtn}>+</button>
                                                    <button onClick={() => handlePointUpdate(u.id, 'sub')} style={styles.subBtn}>-</button>
                                                    <button onClick={() => setShowPlanModal(u.id)} style={styles.viewBtn}>🌟 Premium</button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}

                {activeTab === 'wallet' && (
                    <div style={styles.card}>
                        <h3 style={styles.tabTitle}>WALLET REQUESTS</h3>
                        <div style={{overflowX: 'auto'}}>
                            <table style={styles.table}>
                                <thead>
                                    <tr style={styles.thRow}>
                                        <th style={styles.th}>USER DETAILS</th>
                                        <th style={styles.th}>AMOUNT & PROOF</th>
                                        <th style={styles.th}>ACTION</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {requests.map(req => (
                                        <tr key={req.id} style={styles.tr}>
                                            <td style={styles.td}>
                                                <div style={{
                                                    display: 'inline-block', padding: '2px 8px', borderRadius: '4px',
                                                    fontSize: '10px', fontWeight: 'bold', marginBottom: '5px',
                                                    background: req.type === 'deposit' ? '#238636' : '#da3633', color: '#fff'
                                                }}>
                                                    {req.type?.toUpperCase()}
                                                </div>
                                                <div style={{fontWeight: 'bold', color: '#fff'}}>{req.userEmail}</div>
                                                <div style={{fontSize: '11px', color: '#D4AF37', marginTop: '4px'}}>
                                                    👤 {req.accountName || 'N/A'}<br/>
                                                    📞 {req.phoneNumber || 'N/A'}<br/>
                                                    🏦 {req.paymentMethod || 'No Method'}
                                                </div>
                                            </td>
                                            <td style={styles.td}>
                                                <div style={{fontSize: '16px', fontWeight: 'bold', color: '#fff'}}>{req.amount} MMK</div>
                                                {req.type === 'deposit' && req.screenshot && (
                                                    <button onClick={() => setViewImg(req.screenshot)} style={{marginTop: '8px', padding: '4px 10px', fontSize: '11px', background: '#3498db', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer'}}>
                                                        🖼️ Proof
                                                    </button>
                                                )}
                                            </td>
                                            <td style={styles.td}>
                                                {req.status === 'pending' ? (
                                                    <button onClick={() => handleApprove(req)} style={styles.approveBtn}>Approve</button>
                                                ) : (
                                                    <span style={{color: '#2ecc71', fontWeight: 'bold'}}>Approved ✅</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}

                {activeTab === 'verification' && (
                    <div style={styles.card}>
                        <h3 style={styles.tabTitle}>TASK VERIFICATION</h3>
                        <div style={{overflowX: 'auto'}}>
                            <table style={styles.table}>
                                <thead>
                                    <tr style={styles.thRow}>
                                        <th style={styles.th}>USER & TASK</th>
                                        <th style={styles.th}>PROOF</th>
                                        <th style={styles.th}>ACTION</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {submissions.length > 0 ? submissions.map(sub => (
                                        <tr key={sub.id} style={styles.tr}>
                                            <td style={styles.td}>
                                                <div style={{fontWeight: 'bold', color: '#fff'}}>{sub.userEmail}</div>
                                                <div style={{fontSize: '12px', color: '#D4AF37'}}>{sub.taskTitle} (+{sub.points} Pts)</div>
                                            </td>
                                            <td style={styles.td}>
                                                {sub.screenshot ? (
                                                    <button onClick={() => setViewImg(sub.screenshot)} style={{...styles.viewBtn, background: '#3498db'}}>🖼️ View Proof</button>
                                                ) : 'No Proof'}
                                            </td>
                                            <td style={styles.td}>
                                                {sub.status === 'pending' ? (
                                                    <div style={{display: 'flex', gap: '5px'}}>
                                                        <button onClick={() => handleApproveTask(sub)} style={styles.approveBtn}>Approve</button>
                                                        <button onClick={() => handleTaskReject(sub)} style={{...styles.approveBtn, background: '#da3633'}}>Reject</button>
                                                    </div>
                                                ) : <span style={{color: sub.status === 'approved' ? '#2ecc71' : '#e74c3c', fontWeight: 'bold'}}>{sub.status?.toUpperCase()}</span>}
                                            </td>
                                        </tr>
                                    )) : (
                                        <tr><td colSpan="3" style={{padding: '20px', textAlign: 'center', color: '#555'}}>No tasks found.</td></tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}

                {activeTab === 'tasks' && (
                    <div style={styles.card}>
                        <h3 style={styles.tabTitle}>ADD NEW TASK</h3>
                        <div style={styles.formGrid}>
                            <input placeholder="Task Title" value={taskTitle} onChange={(e) => setTaskTitle(e.target.value)} style={styles.input}/>
                            <select value={taskType} onChange={(e) => setTaskType(e.target.value)} style={styles.input}>
                                <option value="YouTube">YouTube Sub/Like</option>
                                <option value="Website">Website Visit</option>
                                <option value="Ad">Ad View</option>
                            </select>
                            <input placeholder="Task Link" value={taskLink} onChange={(e) => setTaskLink(e.target.value)} style={styles.input}/>
                            <input placeholder="Points" type="number" value={taskPoints} onChange={(e) => setTaskPoints(e.target.value)} style={styles.input}/>
                            <select value={targetMember} onChange={(e) => setTargetMember(e.target.value)} style={styles.input}>
                                <option value="Free">Free Member</option>
                                <option value="Premium">Premium Member</option>
                            </select>
                            <button onClick={handleAddTask} style={styles.saveBtn}>Add Task</button>
                        </div>
                        <h3 style={{...styles.tabTitle, marginTop: '30px'}}>ACTIVE TASKS</h3>
                        {tasks.map(t => (
                            <div key={t.id} style={styles.listItem}>
                                <span>{t.title} ({t.points} Pts) - {t.memberLevel}</span>
                                <button onClick={() => deleteDoc(doc(db, "tasks", t.id))} style={styles.delBtn}>Delete</button>
                            </div>
                        ))}
                    </div>
                )}

                {activeTab === 'videos' && (
                    <div style={styles.card}>
                        <h3 style={styles.tabTitle}>PLAYLIST MANAGEMENT</h3>
                        <div style={styles.formGrid}>
                            <input placeholder="Video Title" value={vidTitle} onChange={(e) => setVidTitle(e.target.value)} style={styles.input}/>
                            <input placeholder="YouTube URL" value={vidUrl} onChange={(e) => setVidUrl(e.target.value)} style={styles.input}/>
                            <button onClick={handleAddVideo} style={styles.saveBtn}>Add to Playlist</button>
                        </div>
                        <div style={{marginTop: '20px'}}>
                            {videos.map(v => (
                                <div key={v.id} style={styles.listItem}>
                                    <span>{v.title}</span>
                                    <button onClick={() => deleteDoc(doc(db, "videos", v.id))} style={styles.delBtn}>Delete</button>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {activeTab === 'promo' && (
                    <div style={styles.card}>
                        <h3 style={styles.tabTitle}>PROMO CODES</h3>
                        <div style={styles.formGrid}>
                            <input placeholder="CODE123" value={pCode} onChange={(e) => setPCode(e.target.value)} style={styles.input}/>
                            <input placeholder="Reward Points" type="number" value={pReward} onChange={(e) => setPReward(e.target.value)} style={styles.input}/>
                            <input placeholder="Usage Limit" type="number" value={pLimit} onChange={(e) => setPLimit(e.target.value)} style={styles.input}/>
                            <button onClick={handleAddPromo} style={styles.saveBtn}>Generate Code</button>
                        </div>
                        <div style={{marginTop: '20px'}}>
                            {promoCodes.map(p => (
                                <div key={p.id} style={styles.listItem}>
                                    <span>{p.code} - {p.reward} Pts ({p.usedBy?.length || 0}/{p.limit})</span>
                                    <button onClick={() => deleteDoc(doc(db, "promo_codes", p.id))} style={styles.delBtn}>Delete</button>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {activeTab === 'settings' && (
                    <div style={styles.card}>
                        <h3 style={styles.tabTitle}>GLOBAL SETTINGS</h3>
                        <div style={styles.formGrid}>
                            <div><label style={styles.label}>YouTube API Key</label><input value={ytApiKey} onChange={(e) => setYtApiKey(e.target.value)} style={styles.input}/></div>
                            <div><label style={styles.label}>Target Channel ID</label><input value={targetChannelId} onChange={(e) => setTargetChannelId(e.target.value)} style={styles.input}/></div>
                            <div><label style={styles.label}>Ads Points (Free)</label><input type="number" value={adsFreePoints} onChange={(e) => setAdsFreePoints(e.target.value)} style={styles.input}/></div>
                            <div><label style={styles.label}>Ads Points (Premium)</label><input type="number" value={adsPremiumPoints} onChange={(e) => setAdsPremiumPoints(e.target.value)} style={styles.input}/></div>
                            <div><label style={styles.label}>Adsterra Link</label><input value={adsterraLink} onChange={(e) => setAdsterraLink(e.target.value)} style={styles.input}/></div>
                            <div><label style={styles.label}>Daily Ad Limit</label><input type="number" value={dailyAdLimit} onChange={(e) => setDailyAdLimit(e.target.value)} style={styles.input}/></div>
                            
                            <div style={{gridColumn: '1/-1', padding: '20px', background: '#111', borderRadius: '10px', marginTop: '20px', border: '1px solid #333'}}>
                                <h4 style={{color: '#D4AF37', marginTop: 0}}>VPN PROTECTION</h4>
                                <div style={{display: 'flex', gap: '20px', alignItems: 'center'}}>
                                    <label><input type="checkbox" checked={vpnCheckEnabled} onChange={(e) => setVpnCheckEnabled(e.target.checked)}/> Enable VPN Check</label>
                                    <select value={vpnAction} onChange={(e) => setVpnAction(e.target.value)} style={styles.miniInput}>
                                        <option value="block">Block Access</option>
                                        <option value="warn">Warning Only</option>
                                    </select>
                                </div>
                            </div>

                            <button onClick={handleSaveSettings} style={{...styles.saveBtn, gridColumn: '1/-1', marginTop: '20px'}}>Save All Settings</button>
                        </div>
                    </div>
                )}
            

            {/* Premium Plan Modal */}
            {showPlanModal && (
                <div style={styles.overlay}>
                    <div style={styles.modalCard}>
                        <h3 style={{color: '#D4AF37', textAlign: 'center'}}>UPGRADE PLAN</h3>
                        <div style={styles.modalGrid}>
                            <button onClick={() => handleMakePremium(showPlanModal, 1)} style={styles.planBtn}>1 Month Premium</button>
                            <button onClick={() => handleMakePremium(showPlanModal, 12)} style={styles.planBtn}>1 Year Premium</button>
                            <button onClick={() => handleMakePremium(showPlanModal, 0, 7)} style={styles.planBtn}>7 Days Trial</button>
                        </div>
                        <button onClick={() => setShowPlanModal(null)} style={styles.closeBtn}>Cancel</button>
                    </div>
                </div>
            )}

            {/* Proof Image View */}
            {viewImg && (
                <div onClick={() => setViewImg(null)} style={styles.overlay}>
                    <img src={viewImg} style={styles.proofImg} alt="Proof" />
                </div>
            )}
        </div>
    );
};

// --- Sub Components ---
const SidebarItem = ({ icon, label, active, onClick }) => (
    <div onClick={onClick} style={styles.sidebarItem(active)}>
        <span className="material-icons-round" style={{fontSize: '20px'}}>{icon}</span>
        <span style={{fontSize: '14px'}}>{label}</span>
    </div>
);

const StatCard = ({ label, value, icon, color }) => (
    <div style={styles.statCard}>
        <div style={{...styles.statIcon, background: color}}>
            <span className="material-icons-round" style={{color: '#fff'}}>{icon}</span>
        </div>
        <div>
            <div style={{fontSize: '12px', color: '#8b949e'}}>{label}</div>
            <div style={{fontSize: '24px', fontWeight: 'bold', color: '#fff'}}>{value}</div>
        </div>
    </div>
);

// --- Styles (အချိုးအစားရော Design ပါ အပြည့်အစုံ) ---
const styles = {
    container: { 
        display: 'flex', 
        height: '100vh', 
        width: '100vw',
        background: '#0a0c10', 
        color: '#c9d1d9', 
        fontFamily: "'Inter', sans-serif",
        overflow: 'hidden' 
    },
    sidebar: { 
        width: '260px', 
        minWidth: '260px', 
        background: '#11141b', 
        padding: '30px 15px', 
        display: 'flex', 
        flexDirection: 'column', 
        borderRight: '1px solid #21262d',
        height: '100vh',
        boxSizing: 'border-box'
    },
    logo: { 
        color: '#D4AF37', 
        fontSize: '24px', 
        fontWeight: '900', 
        textAlign: 'center', 
        marginBottom: '40px', 
        letterSpacing: '2px' 
    },
    mainContent: { 
        flex: 1, 
        padding: '40px', 
        overflowY: 'auto', 
        height: '100vh',
        boxSizing: 'border-box'
    },
    dashboardGrid: { 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', 
        gap: '20px' 
    },
    statCard: { 
        background: '#161b22', 
        padding: '25px', 
        borderRadius: '15px', 
        display: 'flex', 
        alignItems: 'center', 
        gap: '20px', 
        border: '1px solid #30363d' 
    },
    statIcon: { 
        width: '50px', 
        height: '50px', 
        borderRadius: '12px', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        flexShrink: 0 
    },
    card: { 
        background: '#161b22', 
        borderRadius: '20px', 
        padding: '30px', 
        border: '1px solid #30363d',
        width: '100%',
        boxSizing: 'border-box'
    },
    tabTitle: { 
        fontSize: '20px', 
        fontWeight: '800', 
        marginBottom: '25px', 
        color: '#fff', 
        borderLeft: '4px solid #D4AF37', 
        paddingLeft: '15px' 
    },
    table: { width: '100%', borderCollapse: 'collapse' },
    thRow: { borderBottom: '1px solid #30363d' },
    tr: { borderBottom: '1px solid #21262d' },
    th: { textAlign: 'left', padding: '15px', color: '#8b949e', fontSize: '13px', fontWeight: '600' },
    td: { padding: '15px', fontSize: '14px' },
    
    label: { display: 'block', fontSize: '12px', color: '#8b949e', marginBottom: '5px' },
    input: { 
        width: '100%', 
        padding: '12px', 
        background: '#0d1117', 
        border: '1px solid #30363d', 
        borderRadius: '8px', 
        color: '#fff', 
        marginBottom: '15px',
        boxSizing: 'border-box'
    },
    formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' },
    
    // Buttons
    saveBtn: { background: '#D4AF37', color: '#000', border: 'none', padding: '14px 30px', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' },
    addBtn: { background: '#238636', color: '#fff', border: 'none', width: '30px', height: '30px', borderRadius: '6px', cursor: 'pointer' },
    subBtn: { background: '#da3633', color: '#fff', border: 'none', width: '30px', height: '30px', borderRadius: '6px', cursor: 'pointer' },
    viewBtn: { background: '#30363d', color: '#fff', border: 'none', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' },
    delBtn: { background: 'transparent', color: '#da3633', border: '1px solid #da3633', padding: '4px 10px', borderRadius: '4px', cursor: 'pointer', fontSize: '11px' },
    approveBtn: { background: '#238636', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' },
    backBtn: { 
    padding: '12px', 
    background: 'transparent', 
    color: '#da3633', 
    border: '1px solid #da3633', 
    borderRadius: '10px', 
    cursor: 'pointer', 
    fontWeight: 'bold',
    marginTop: '20px',    // အပေါ်က Menu တွေနဲ့ မကပ်အောင်
    width: '100%',        // Sidebar အပြည့်ယူမယ်
    flexShrink: 0         // ဘယ်လိုပဲဖြစ်ဖြစ် ပိန်မသွားအောင်
},
    
    miniInput: { width: '60px', padding: '6px', background: '#0d1117', border: '1px solid #30363d', color: '#fff', borderRadius: '4px' },
    listItem: { display: 'flex', justifyContent: 'space-between', padding: '12px', background: '#0d1117', borderRadius: '8px', marginBottom: '10px', border: '1px solid #30363d', alignItems: 'center' },
    
    // Modals & Overlays
    overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 },
    proofImg: { maxWidth: '90%', maxHeight: '80%', borderRadius: '12px', border: '2px solid #D4AF37' },
    modalCard: { background: '#161b22', padding: '30px', borderRadius: '20px', width: '340px', border: '1px solid #30363d' },
    modalGrid: { display: 'flex', flexDirection: 'column', gap: '10px' },
    planBtn: { background: '#0d1117', border: '1px solid #30363d', color: '#fff', padding: '14px', borderRadius: '10px', cursor: 'pointer', textAlign: 'center', fontWeight: '600' },
    closeBtn: { width: '100%', marginTop: '15px', background: 'transparent', color: '#8b949e', border: 'none', cursor: 'pointer' },
    
    sidebarItem: (active) => ({
        display: 'flex', alignItems: 'center', gap: '15px', padding: '12px 15px', borderRadius: '10px', cursor: 'pointer', marginBottom: '5px',
        background: active ? 'rgba(212, 175, 55, 0.1)' : 'transparent',
        color: active ? '#D4AF37' : '#8b949e',
        transition: 'all 0.2s'
    })
};

export default AdminPanel;